/**
 * Enum for compliance report meta fields. We're mapping the enum values to the actual
 * field names used in the compliance report schema to ensure consistency across the codebase.
 */
export enum ComplianceReportMetaField {
  Teams = 'teams',
  Owners = 'owners',
  DataProtectionOfficer = 'dataProtectionOfficer',
  Title = 'title',
  Description = 'description',
}
